class AdpListItemController {
  constructor() {
    this.name = 'adpListItem';
  }
}

export default AdpListItemController;



// WEBPACK FOOTER //
// ./src/app/components/adpListItem/adpListItem.controller.js